import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl, imgurl } from "../../baseurl";
import Swal from "sweetalert2";
import NavigateHome from "../../component/utils/NavigateHome";
import PageCount from "../../component/utils/PageCount";
import FooterTwo from "../../component/FooterTwo";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2500,
  timerProgressBar: true,
});

function ProfileImages() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");

  // Load existing uploaded images
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await axios.get(`${baseurl}getUserProfileImages`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setImages(res.data.images || []);
      } catch (err) {
        console.error("Error fetching images:", err);
      }
      setLoading(false);
    };

    fetchImages();
  }, []);

  // Upload image
  const handleImageUpload = async (e) => {
    const selectedFiles = Array.from(e.target.files);

    if (images.length + selectedFiles.length > 10) {
      Toast.fire({
        icon: "error",
        title: "You can upload a maximum of 10 images.",
      });
      return;
    }

    const formData = new FormData();
    selectedFiles.forEach((file) => formData.append("images", file));

    try {
      const res = await axios.post(`${baseurl}uploadUserImages`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setImages(res.data.images);
      Toast.fire({ icon: "success", title: "Images uploaded!" });
    } catch (err) {
      console.error("[UPLOAD ERROR]", err.response?.data || err);
      Toast.fire({ icon: "error", title: "Upload failed" });
    }
  };

  // Delete image
  const deleteImage = async (imgId) => {
    Swal.fire({
      title: "Delete this image?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await axios.post(
            `${baseurl}deleteUserImage`,
            { image_id: imgId },
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );

          setImages(res.data.images);
          Toast.fire({ icon: "success", title: "Deleted" });
        } catch (err) {
          Toast.fire({ icon: "error", title: "Delete failed" });
        }
      }
    });
  };

  if (loading) return <p className="text-center mt-4">Loading...</p>;

  return (

     <>

     
    <section className="section-image">
      <PageCount pageName = {"User Profile image"}/>
      <NavigateHome/>
      <div className="profile-image-container">
        <h2 className="text-center mb-4">Upload Your Profile Photos</h2>
        <p className="text-center text-muted mb-3">
          Upload clear, recent photographs. You can upload <b>up to 10 images</b>.
        </p>

        {/* Image Grid */}
        <div className="image-grid">

          {/* Existing Images */}
          {images.map((img) => (
            <div className="image-card" key={img.id}>
              <img src={`${imgurl}${img.image}`} alt="profile" />
              <button className="delete-btn" onClick={() => deleteImage(img.id)}>
                ✕
              </button>
            </div>
          ))}

          {/* ONLY ONE Upload Box */}
          {images.length < 10 && (
            <label className="upload-box-grid">
              <span className="plus-icon">+</span>
              <input
                type="file"
                accept="image/*"
                multiple
                hidden
                onChange={handleImageUpload}
              />
            </label>
          )}
        </div>

        <div className="text-center mt-4">
          <button
            className="btn-primary"
            onClick={() => (window.location.href = "/about-user")}
          >
            Complete →
          </button>
        </div>
      </div>

      <style>{`

      .section-image{
      background: #fff7fa;
    padding: 25px 0;}

        .profile-image-container {
          max-width: 700px;
          margin: auto;
          padding: 20px;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 0 15px rgba(0,0,0,0.08);

          
        }

        .image-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 12px;
        }

        .image-card {
          position: relative;
          border-radius: 10px;
          overflow: hidden;
          height: 260px;
        }

        .image-card img {
          width: 100%;
          height: 100%;
          object-fit: fill;
          border: 2px dashed #adadad;
        }

        .delete-btn {
          position: absolute;
          top: 6px;
          right: 6px;
          background: rgba(0,0,0,0.5);
          color: white;
          border: none;
          border-radius: 50%;
          width: 24px;
          height: 24px;
          cursor: pointer;
        }

        /* Single Upload Box */
        .upload-box-grid {
          height: 260px;
          border: 2px dashed #bbb;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          background: #fafafa;
        }

        .plus-icon {
          font-size: 40px;
          font-weight: bold;
          color: #777;
        }
 
      `}</style>
    </section>

    <FooterTwo />

   </>
  );
}

export default ProfileImages;
